export const ONBOARDING = {
  IS_BROKER_SAVED: 'isBrokerSaved',
  IS_BROKER_CONNECTION_SUCCESS: 'isBrokerConnectionSuccess',
  IS_STRATEGY_SUBSCRIBED: 'isStrategySubscribed'
}